module.exports = __webpack_public_path__ + "static/web-development-70fd41d9fdb202b249f6f89563a46bd7.jpg";